<div class="row">
    <div class="col-auto">
        <ul class="mb-0">
            <li class="">
                공급대상 회사에 차량 정보를 표시
            </li>
        </ul>
    </div>
</div>

<div class="row mt-3">
    <!-- <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div> -->
    <div class="col-auto">
        <label class="mb-0">
            <i class="mdi mdi-car"></i>
            <span class="ml-2">{{currentCarInfo?.dtgCarNo}}</span>
        </label>
    </div>
    <div class="col"></div>
    <ng-container *ngIf="userGroupId <= 1">
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickAddCompany()">
            <i class="fas fa-plus"></i>
            <span class="ml-1">
                공급회사설정
            </span>
        </button>
    </div>
    </ng-container>
</div>

<div class="table-responsive mt-3">
    <table class="table table-sm table-hover align-items-center mb-0">
        <thead class="">
            <tr>
                <th>
                    차번호
                </th>
                <th>
                    소속회사
                </th>
                <th>
                    공급대상회사
                </th>
                <th>
                    표시상태
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngIf="listItem">
                <tr *ngFor="let item of listItem;">
                    <td>
                        {{item.dtgCarNo}}
                    </td>
                    <td>
                        {{item.companyNm}}
                    </td>
                    <td>
                        {{item.extCompanyNm}}
                    </td>
                    <td>
                        <select class="form-control form-control-sm w-auto"
                            [(ngModel)]="item.useYn"
                            (change)="changeUseYn(item)">
                            <option [value]="'Y'">표시중</option>
                            <option [value]="'N'">미표시</option>
                        </select>
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="!listItem">
                <tr>
                    <td class="text-center" colspan="4">
                        표시 할 내용이 없습니다
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>